import { useEffect } from 'react';
import useRequestContext from 'hooks/user/useRequestContext';
import useSegmentation from 'hooks/user/useSegmentation';
import { cookieConsentId } from './shared/constants';
import { createScript } from './shared/helpers';

export default function CookieConsentLoader() {
    const { culture } = useSegmentation();
    const { isClubMatasApp, posRequest } = useRequestContext();
    const { isPosRequest } = posRequest || {};
    const languageCode = culture.split('-')[0].toUpperCase();

    useEffect(() => {
        const cookieConsentLoaded = document.getElementById(cookieConsentId);

        if (cookieConsentLoaded || isClubMatasApp || isPosRequest) {
            return;
        }

        document.body.appendChild(createScript(languageCode));
    }, [languageCode, isClubMatasApp, isPosRequest]);

    return null;
}
